import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  AdminService,
  PendingPlatePhoto,
} from 'src/app/services/admin-service';

// Admin moderation queue for member-submitted plate photos (Plate Image
// Researcher). Member uploads land pending and are NOT public until approved
// here. Each card shows the photo, the registration it is filed under and the
// car details, with approve / reject. Verify-gated like the editorial queue.
@Component({
  selector: 'pla-admin-plate-photos',
  templateUrl: './admin-plate-photos.component.html',
  styleUrls: ['./admin-plate-photos.component.scss'],
})
export class AdminPlatePhotosComponent implements OnInit {
  public verified = false;
  public loading = true;
  public photos: PendingPlatePhoto[] = [];
  public acting = new Set<number>();
  public toast = '';
  private toastTimer: any = null;

  constructor(private router: Router, private admin: AdminService) {}

  ngOnInit(): void {
    this.admin.verify().subscribe(
      (data: { admin: boolean }) => {
        if (!data || !data.admin) {
          this.router.navigate(['/landing']);
          return;
        }
        this.verified = true;
        this.load();
      },
      () => this.router.navigate(['/landing'])
    );
  }

  public load(): void {
    this.loading = true;
    this.admin.getPendingPlatePhotos().subscribe(
      (rows) => {
        this.photos = rows || [];
        this.loading = false;
      },
      () => {
        this.photos = [];
        this.loading = false;
      }
    );
  }

  public approve(p: PendingPlatePhoto): void {
    if (this.acting.has(p.id)) return;
    this.acting.add(p.id);
    this.admin.approvePlatePhoto(p.id).subscribe(
      () => this.remove(p, `${p.registration} approved — now public`),
      () => this.fail(p)
    );
  }

  public reject(p: PendingPlatePhoto): void {
    if (this.acting.has(p.id)) return;
    this.acting.add(p.id);
    this.admin.rejectPlatePhoto(p.id).subscribe(
      () => this.remove(p, `${p.registration} rejected`),
      () => this.fail(p)
    );
  }

  private remove(p: PendingPlatePhoto, msg: string): void {
    this.photos = this.photos.filter((x) => x.id !== p.id);
    this.acting.delete(p.id);
    this.showToast(msg);
  }

  private fail(p: PendingPlatePhoto): void {
    this.acting.delete(p.id);
    this.showToast('Could not complete that just now.');
  }

  private showToast(msg: string): void {
    this.toast = msg;
    if (this.toastTimer) clearTimeout(this.toastTimer);
    this.toastTimer = setTimeout(() => (this.toast = ''), 3200);
  }

  public carLine(p: PendingPlatePhoto): string {
    return [p.make, p.model, p.colour].filter(Boolean).join(' · ');
  }
}
